import React from 'react';

export const InvoicePageError: React.FC = () => (
  <div className="content flex-one flex-box-column invoices">
    <div className="no-data">
      <h2>{t('no-data.error.message')}</h2>
      <p>{t('warning.try-again-later')}</p>
    </div>
  </div>
);
